import { BundleModifyTypes, PurchaseTypes } from "../app/shared/types/flows-config.types";
import { BundleEditionTypes } from "../app/shared/types/order.type";

const base_api = "https://farmbox-tx-back-dev.navego.tech";

export const environment = {
  production: false,
  apis: {
    v1: `${base_api}`,
    v2: `${base_api}/api/v2`,
    v3: `${base_api}/api/v3`,
    google: {
      places: 'AIzaSyBTHTviZ7QPtEjH29Jmmkp13RO8LPrxppM'
    },
    firebase: {
      apiKey: "AIzaSyBssokOqsxCeDU_IYXwQWB9NWA6mWOnDp4",
      authDomain: "dev-pet-wants.firebaseapp.com",
      projectId: "dev-pet-wants",
      storageBucket: "dev-pet-wants.firebasestorage.app",
      messagingSenderId: "430314372585",
      appId: "1:430314372585:web:4fe54ef9dbf928f51cdf78",
      measurementId: "G-B0ZSR0HHJ1"
    },
    klaviyo: {
      publicApiKey: 'Ufqp3c'
    },
    maintenance: {
      url: 'https://ecommerce-configurations.navego.tech/api/v3/maintenance?url=petwants-stg'
    },
    authorize: {
      APILoginID: '859vpT8YqF',
      PublicClientkey: '2789LLpawLnj4TJe2s5k7akamxnXS3aTq442sEs4vkU82JnTQ56e93fNuMUXmfC6'
    },
    turnstile: {
      // Its own key pair, separate from production: a leaked dev secret must not
      // validate a token against the real backend. The dev backend has to hold
      // THIS widget's secret (DEV-11124). Empty until the widget exists for the
      // hostname petwants-front-dev.navego.tech.
      //
      // Cloudflare's test keys exercise what it will not hand out on demand:
      //   3x00000000000000000000FF  forces the interactive challenge
      //   2x00000000000000000000AB  always fails, so the token stays null
      //   1x00000000000000000000AA  always passes
      siteKey: ''
    }
  },
  application: {
    angular: 'Angular 19.2.6',
    bootstrap: 'Bootstrap 5.3.2',
    fontawesome: 'Font Awesome 6.5.1',
    name: 'Pet Wants',
    version: '1.0.0',
  },
  config: {
    bodyClass: 'app-me',
    crypto: {
      key: '',
    },
    flows: {
      territories: false,
      membership: true,
      settings: {
        toHide: {
          membership: 'Membership'
        },
        profile: {
          hasPickupLocationsFlow: true
        },
        deliveryDayUpdates: {
          displayOnlyActiveReescheduledOrder: true
        }
      },
      specialMembership: {
        defaultRoute: '/order/custom-box/' + BundleEditionTypes.subscription,
        settings: {
          hideHeaderCategoriesNav: true
        },
      },
      order: {
        askForDonationOnSkip: false,
        showFreeDeliverySlider: false,
        voluntaryDonationFlow: false,
        showProductStatusTag: false,
        hasDriveTipsFlow: false,
      },
      bundles: {
        modifyType: BundleModifyTypes.outOfOrder,
      },
      shop: {
        validateMarketState: true
      },
      login: {
        tempResetPassword: true
      },
      purchase: {
        type: PurchaseTypes.anet
      },
      signup: {
        // The signup will not advance until the address is proved through the
        // emailed link. It has to move in step with the backend's
        // `signup_email_verification_required` parameter: on here with theirs
        // off sends emails that gate nothing, and the other way round
        // `POST /account` (and `/explorer/activate`) answer 403 for the
        // missing `verificationToken`.
        requiresEmailVerification: false
      },
      welcomePage: {
        categoryToFetch: 10
      },
      /** Explorer (anonymous shopper) flow — DEV-11262.
       *  On in development so the flow can be exercised; production stays off
       *  until the backend is confirmed live. See environment.ts. */
      explorer: {
        enabled: true
      }
    },
    filesVersionNumber: {
      logo: 2
    },
    friendReferral: {
      baseUrl: 'petwants-front-stg.navego.tech/signup?utm_source=friend_referral&utm_medium=share&utm_campaign='
    },
    seo: {
      mainTitle: 'Pet Wants Cincinnati | Fresh, Natural Pet Food & Supplies in Cincinnati, OH',
      mainDescription: 'Pet Wants Cincinnati offers fresh, nutritious pet food and natural products for your furry friends. Locally made, always fresh, and delivered to your door in Cincinnati.',
      baseTitle: 'Pet Wants Cincinnati',
      baseKeywords: ['Fresh', 'Pet', 'Food', 'Cincinnati', 'Natural pet products', 'Pet food delivery Cincinnati', 'Holistic pet care', 'Local pet store Cincinnati'],
      type: 'website',
      baseURL: 'https://petwantscincy.com/'
    },
    contactEmail: 'delivery@petwantscincy.com'
  },
};
